import { z } from 'zod';

import { InstagramCreatorAgeBucket } from '@frontend/gql/social/graphql';

export const INSTAGRAM_CREATOR_AGE_BUCKET = {
  AGE_18_TO_24: 'AGE_18_TO_24',
  AGE_25_TO_34: 'AGE_25_TO_34',
  AGE_35_TO_44: 'AGE_35_TO_44',
  AGE_45_TO_54: 'AGE_45_TO_54',
  AGE_55_TO_64: 'AGE_55_TO_64',
  AGE_65_AND_ABOVE: 'AGE_65_AND_ABOVE',
} as const satisfies Record<string, InstagramCreatorAgeBucket>;

export const InstagramCreatorAgeBucketSchema = z.nativeEnum(INSTAGRAM_CREATOR_AGE_BUCKET);
